export const getSearchParam = (parameter = "", location = window.location) => {
    const params = new URLSearchParams(location.search);
    return params.get(parameter) || "";
};
